module.exports = __webpack_public_path__ + "static/media/logo2.77567f68.png";